import { FC, useEffect, useState } from 'react'
import { Alert, Divider, Input, message } from 'antd'
import { useNavigate } from 'react-router-dom'
import { Modal } from '../../../../ui'
import { ButtonsBlock } from '../../../../Edit/components'
import useRequest from '../../../../hooks/useRequest'
import { postApprove } from '../../../config'
import style from './style.m.less'
import {useCurrentUser} from "../../../../hooks/useCurrentUser";
import IAppState from 'store/states'
import { useSelector } from 'react-redux'
import moment from 'moment'
import {signBody} from "../../../../helpers";
import { useTranslation } from 'react-i18next'
const { TextArea } = Input

interface IRefuseModal {
    isModalVisible: boolean
    setIsModalVisible: (value: boolean) => void
    currentDate: string
    id?: string
}

const RefuseModal: FC<IRefuseModal> = ({ isModalVisible, setIsModalVisible, currentDate, id }) => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const [reason, setReason] = useState('')
    const { fetch } = useRequest(postApprove)
    const userInfo = useSelector((store: IAppState) => store.user)
    const { data } = userInfo
    const { isUserAdmin } = useCurrentUser()
    const isEmptySign = isUserAdmin && !data?.certificate_data
    const isSignExpired = isUserAdmin && !isEmptySign && !moment(data?.certificate_data.token_expiration).isAfter()

    const handleOk = () => {
        setIsModalVisible(false)
    }

    useEffect(() => {
        if (!isModalVisible) {
            setReason('')
        }
    }, [isModalVisible])

    const getBack = async () => {
        if (!reason) {
            message.error('Укажите комментарий длиной [1 -500] символов.')
            return
        }
        const body = {
            id: Number(id),
            action_type_id: 2,
            reason: reason,
        }
        if (isUserAdmin) {
            const {request_id, signature} = await signBody(body, data)
            fetch({
                body,
                getParams: {
                    request_id,
                },
                config: {
                    headers: {
                        Signature: signature,
                    },
                },
                successMessage: {
                    title: 'Отказ отправлен',
                    description: `Данные КУ за ${currentDate} отклонены, комментарий направлен пользователю`,
                },
                errorCodeMessage: true,
                onSuccess: () => navigate(-1),
            })
        } else {
            fetch({
                body,
                successMessage: {
                    title: 'Отказ отправлен',
                    description: `Данные КУ за ${currentDate} отклонены, комментарий направлен пользователю`,
                },
                errorCodeMessage: true,
                onSuccess: () => navigate(-1),
            })
        }
    }

    return (
        <Modal isModalVisible={isModalVisible}>
            <div className={style.modalWrapper}>
                <div className={style.header}>Отказ в согласовании данных</div>
            </div>
            <div className={style.text}>
                <div>Причина отказа</div>
                <TextArea
                    className={style.textArea}
                    rows={4}
                    placeholder="Ваш комментарий"
                    value={reason}
                    maxLength={500}
                    onChange={(e) => setReason(e.target.value)}
                />
            </div>
            <Alert
                className={style.modalAlert}
                message="Указанный комментарий увидит пользователь"
                type="warning"
                showIcon
            />
            {(isEmptySign || isSignExpired) && (
                <>
                    <Divider />
                    <Alert
                        className={style.signError}
                        message={isEmptySign ? 'Не установлена ЭП' : 'Истек срок действия ЭП'}
                        type="error"
                        showIcon
                    />
                </>
            )}
            <div className={style.buttonsBlock}>
                <ButtonsBlock
                    confirmAction={getBack}
                    cancelAction={handleOk}
                    confirmTitle={isUserAdmin
                        ? t('questionnaireApprovalItem.signModalButtonTitle')
                        : t('questionnaireApprovalItem.modalButtonTitle')}
                    confirmDisabled={isEmptySign || isSignExpired}
                />
            </div>
        </Modal>
    )
}

export default RefuseModal
